// The transport-neutral error model (SPEC §9.1). Shared by every transport and
// surfaced in the public API as a string code plus optional message.
// Build an Error carrying a KpsReason's code, for surfacing through stream/
// connection rejections.
export function streamError(reason) {
    const e = new Error(reason.message ?? `kps: stream ${reason.code ?? 'reset'}`);
    e.code = reason.code;
    return e;
}
// Coerce an arbitrary throwable / abort reason into a KpsReason.
export function reasonFrom(x) {
    if (x == null)
        return undefined;
    if (typeof x === 'object' && ('code' in x || 'message' in x))
        return x;
    return { message: String(x?.message ?? x) };
}
//# sourceMappingURL=errors.js.map